export default __webpack_public_path__ + "static/NuvemFiscalHome3-4b49f8c8f23c25d26b7f60b2f1550b12.png";